import { Operation, op } from "libs/transaction";
import { getPointer, RecordValue } from "libs/schema";
import { stringComparer } from "libs/comparers";

export type UpdateThreadRequestLastResolvedAtProps = {
  request: Pick<RecordValue<"thread_request">, "id" | "last_request_timeline_order">;
  lastResolvedAt: {
    sent_at: string;
    timeline_order: string;
  } | null;
};

export function updateThreadRequestLastResolvedAt(props: UpdateThreadRequestLastResolvedAtProps): Operation[] {
  const requestPointer = getPointer("thread_request", props.request.id);

  if (!props.lastResolvedAt) {
    return [
      op.update(requestPointer, {
        resolved_at: null,
        last_resolved_at: null,
        last_resolved_at_timeline_order: null,
      }),
    ];
  }

  const isResolved =
    stringComparer(props.lastResolvedAt.timeline_order, props.request.last_request_timeline_order, true) >= 0;

  return [
    op.update(requestPointer, {
      resolved_at: isResolved ? props.lastResolvedAt.sent_at : null,
      last_resolved_at: props.lastResolvedAt.sent_at,
      last_resolved_at_timeline_order: props.lastResolvedAt.timeline_order,
    }),
  ];
}
